const initialState = {};
export default function simple(state = initialState, action) {
    return state;
}